import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import {
  appInitialState,
  applicationStateReducer,
} from './+state/application-state.reducer';
import { AppStateReloaderComponent } from './app-state-reloader/app-state-reloader.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [AppStateReloaderComponent],
  exports: [AppStateReloaderComponent],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature('appState', applicationStateReducer, {
      initialState: appInitialState,
    }),
  ],
})
export class ApplicationStateModule {}
